import React from "react";

import type { SideLoadedBusinessGridContext } from "components/Business/SideLoadedBusinesses/useSideLoadedBusinessGridContext";

interface SideLoadedBusinessIsUsedRendererProps {
  context: SideLoadedBusinessGridContext;
  data: SideLoadedBusiness;
}

export function SideLoadedBusinessIsUsedRenderer({
  context,
  data,
}: SideLoadedBusinessIsUsedRendererProps) {
  const { businessesById } = context;
  const { businessIds } = data;

  if (businessIds.length === 0) {
    return (
      <div title="This SideLoaded business has not yet been mapped to any businesses.">
        No
      </div>
    );
  }

  const businesses = businessIds.map(id => businessesById[id]);
  const businessNames = businesses
    .map(business => business?.name)
    .filter(Boolean)
    .join(", ");
  const title = businessNames
    ? `This SideLoaded business has been mapped to the following businesses: ${businessNames}`
    : "This SideLoaded business has not yet been mapped to any businesses.";
  return <div title={title}>Yes</div>;
}
